module.exports = __webpack_public_path__ + "img/img1_mobile.1189100c.png";